module.exports = __webpack_public_path__ + "images/emoji/low_brightness.da3615b99c79fa1aabf1.png";